import './accordion.scss';

class Accordion {
    constructor (element) {
        this.$accordion = element;
    }

    initialize () {
        if (this.$accordion) {
            this.setEvents();
        }
    }

    setEvents () {
        const $$accordionHeaders = this.$accordion.querySelectorAll('.accordion__item-header');

        for (let i = 0; i < $$accordionHeaders.length; i++) {
            const $accordionHeader = $$accordionHeaders[i];

            $accordionHeader.addEventListener('click', (e) => {
                const $accordionItem = $accordionHeader.parentElement;
                const $accordionContent = $accordionItem.querySelector('.accordion__item-content');
                const $accordionContentInner = $accordionItem.querySelector('.accordion__item-content-inner');
                const contentHeight = $accordionContentInner.offsetHeight;
                const contentContainerHeight = $accordionContent.offsetHeight;
                if (contentContainerHeight > 0) {
                    $accordionItem.classList.remove('is--active');
                    $accordionContent.style.maxHeight = contentHeight + 'px';
                    setTimeout(() => {
                        $accordionContent.style.maxHeight = '0';
                    }, 100);

                    const $$productSupportAccordionButtons = $accordionContent.querySelectorAll('.product-support-accordion-toggle-button');
                    if ($$productSupportAccordionButtons.length > 0) {
                        for (let j = 0; j < $$productSupportAccordionButtons.length; j++) {
                            const $productSupportAccordionButton = $$productSupportAccordionButtons[j];
                            if ($productSupportAccordionButton.classList.contains('is--opened')) {
                                $productSupportAccordionButton.classList.remove('is--opened');
                                const $productSupportAccordionContent = $productSupportAccordionButton.closest('.product-support-result__table-list-container').querySelector('.product-support-accordion-list-hidden');
                                const $productSupportAccordionContentComponent = $productSupportAccordionButton.closest('.product-support-result__table-list-container').querySelector('.product-support-result__table-children');
                                $productSupportAccordionContent.style.maxHeight = 0;
                                if ($productSupportAccordionContentComponent) {
                                    $productSupportAccordionContentComponent.style.maxHeight = 0;
                                }
                            }
                        }
                    }
                } else {
                    $accordionItem.classList.add('is--active');
                    $accordionContent.style.maxHeight = contentHeight + 'px';
                    setTimeout(() => {
                        $accordionContent.style.maxHeight = 'none';
                    }, 500);
                    setTimeout(() => {
                        const y = $accordionItem.getBoundingClientRect().top + window.scrollY;
                        window.scroll({
                            top: y,
                            behavior: 'smooth'
                        });
                    }, 600);
                    setTimeout(() => {
                        const $header = document.querySelector('[data-header="root"]');
                        if ($header) {
                            if ($header.classList.contains('is--visible')) {
                                let y = $accordionItem.getBoundingClientRect().top + window.scrollY;
                                y = y - $header.offsetHeight;

                                window.scroll({
                                    top: y,
                                    behavior: 'smooth'
                                });
                            }
                        }
                    }, 800);
                }
            });
        }
    }
}

export { Accordion };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$accordions = $context.querySelectorAll('[data-accordion]');

        if ($$accordions.length > 0) {
            for (let i = 0; i < $$accordions.length; i++) {
                const $$accordion = new Accordion($$accordions[i]);
                $$accordion.initialize();
            }
        }
    }
});
